<template>
  <section class="document-history">
    <loader-dots v-if="loadStatus" />
    
    <list-items-loadable
      v-else
      v-slot="{ item }"
      :items="historyItems"
      empty-text="Нет истории документа."
    >
      <div
        class="document-history__item"
        :class="{ _future: isFuture(item.date) }"
      >
        <div class="document-history__date">{{ item.date | formatDate }}</div>
        <div class="document-history__text" v-html="item.text"></div>
      </div>
    </list-items-loadable>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from '@src/lib/moment';

import ListItemsLoadable from '@@/shared/list/ListItemsLoadable';
import LoaderDots from '@@/shared/loaders/LoaderDots';

import NormaCsLinkHandler from '@@/document/mixins/NormaCsLinkHandler';

export default {
  components: {
    ListItemsLoadable,
    LoaderDots
  },

  mixins: [NormaCsLinkHandler],

  props: {
    documentId: {
      type: String,
      required: true
    },
    loadStatus: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters({
      historyItems: 'currentDocumentHistory'
    })
  },

  mounted() {
    this.initNormaCsLinkHandler(this.$el);
  },

  methods: {
    isFuture(date) {
      return moment(date, 'YYYY-MM-DD').isAfter(moment());
    }
  }
};
</script>
